'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$FeatureCode$() {
  this.c7F = null;
  this.c7G = false;
  this.c7D = null;
  this.c7E = false;
}
export { $c_Lpresto_types$FeatureCode$ as $c_Lpresto_types$FeatureCode$ };
$p = $c_Lpresto_types$FeatureCode$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$FeatureCode$;
/** @constructor */
function $h_Lpresto_types$FeatureCode$() {
}
export { $h_Lpresto_types$FeatureCode$ as $h_Lpresto_types$FeatureCode$ };
$h_Lpresto_types$FeatureCode$.prototype = $p;
$p.cJ6 = (function() {
  if ((!this.c7G)) {
    this.c7F = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c7G = true;
  }
  return this.c7F;
});
$p.ae0 = (function() {
  if ((!this.c7E)) {
    this.c7D = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.c7E = true;
  }
  return this.c7D;
});
var $d_Lpresto_types$FeatureCode$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$FeatureCode$, "presto.types$FeatureCode$", ({
  a0d: 1,
  D: 1
}));
export { $d_Lpresto_types$FeatureCode$ as $d_Lpresto_types$FeatureCode$ };
var $n_Lpresto_types$FeatureCode$;
function $m_Lpresto_types$FeatureCode$() {
  if ((!$n_Lpresto_types$FeatureCode$)) {
    $n_Lpresto_types$FeatureCode$ = new $c_Lpresto_types$FeatureCode$();
  }
  return $n_Lpresto_types$FeatureCode$;
}
export { $m_Lpresto_types$FeatureCode$ as $m_Lpresto_types$FeatureCode$ };
//# sourceMappingURL=presto.types$-Feature-Code$.js.map
